import magnifiAPIInstance from "./apiInstance";

export const matchScheduleAPIs = {
  getMatchSchedule: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/match-schedule`, payload),
  getMatchScheduleById: ({ entityId, matchScheduleId }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/match-schedule/${matchScheduleId}`),
  createMatchSchedule: ({ entityId, payload, isFromInternalSchedule }) =>
    magnifiAPIInstance.post(
      `/api/v3/entities/${entityId}/match-schedule?isFromInternalSchedule=${isFromInternalSchedule ? true : false}`,
      payload,
    ),
  updateMatchSchedule: ({ entityId, matchScheduleId, payload, isFromInternalSchedule }) =>
    magnifiAPIInstance.patch(
      `/api/v3/entities/${entityId}/match-schedule/${matchScheduleId}?isFromInternalSchedule=${isFromInternalSchedule ? true : false}`,
      payload,
    ),
  validateMatchScheduleCsv: ({ entityId, payload, isFromInternalSchedule }) =>
    magnifiAPIInstance.post(
      `/api/v3/entities/${entityId}/match-schedule/validate-csv?isFromInternalSchedule=${isFromInternalSchedule ? true : false}`,
      payload,
    ),
  bulkCreateMatchSchedule: ({ entityId, payload }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/match-schedule/bulk-create`, payload),
  validateNewsScheduleCsv: ({ entityId, payload, isFromInternalSchedule }) =>
    magnifiAPIInstance.post(
      `/api/v3/entities/${entityId}/news-schedule/validate-csv?isFromInternalSchedule=${isFromInternalSchedule ? true : false}`,
      payload,
    ),
  bulkCreateNewsSchedule: ({ entityId, payload }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/news-schedule/bulk-create`, payload),
  exportMatchScheduleCsv: ({ entityId, payload }) =>
    magnifiAPIInstance.get(
      `/api/v3/entities/${entityId}/match-schedule/export-csv?startTime=${payload?.startTime}&endTime=${payload?.endTime}`,
      payload,
    ),
  triggerMatchScheduleManualIngestion: ({ entityId }) =>
    magnifiAPIInstance.get(`/api/v3/ingestion/${entityId}/trigger`),
  deleteMatchSchedule: ({ entityId, matchScheduleId }) =>
    magnifiAPIInstance.delete(`/api/v3/entities/${entityId}/match-schedule/${matchScheduleId}`),
};
